import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('usuario', 'perfil');

const perfilActions = {
  ...genericActions(basePath),
};

export default resource => resource(`${basePath}`, {}, perfilActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/perfil.js